import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import {
  isMobileScreen,
  isPhabletScreen,
  isTabletScreen,
  isLaptopScreen
} from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';

import { useUserInteractionStatisticsContext } from '../../context/UserInteractionStatistics';

import ChartContainer from './ChartContainer';

import Table from './Table';
import PieChart, {
  INSIDE_LABEL_POSITION,
  MOBILE_PIE_RADIUS,
  OUTSIDE_LABEL_POSITION,
  PIE_RADIUS
} from './PieChart';

const UserInteractionChartContainer = ({ location }) => {
  const {
    userInteractionStatistics,
    propertyTypeWithMoreInteractions,
    secondPropertyTypeWithMoreInteractions,
    propertyTypeWithLessInteractions
  } = useUserInteractionStatisticsContext();

  const isThinScreen = () =>
    isMobileScreen() ||
    isPhabletScreen() ||
    isTabletScreen() ||
    isLaptopScreen();

  const pieRadius = isMobileScreen() ? MOBILE_PIE_RADIUS : PIE_RADIUS;
  const labelPosition = isThinScreen()
    ? INSIDE_LABEL_POSITION
    : OUTSIDE_LABEL_POSITION;

  if (userInteractionStatistics.length === 0) {
    return null;
  }

  const title = trans('chart.user.interaction.title', { city: location.city });

  const chartAriaLabel = `${title}: ${userInteractionStatistics.map(s => `${s.label} ${s.percentage}%`).join(', ')}`;

  return (
    <ChartContainer
      id="user-interaction-chart"
      location={location}
      title={title}
      chartAriaLabel={chartAriaLabel}
      subtitle={trans('chart.user.interaction.subtitle', {
        city: location.city,
        country: trans(`country.${location.country}`),
        propertyTypeWithMoreInteractions
      })}
      summary={trans('chart.user.interaction.summary', {
        city: location.city,
        propertyTypeWithMoreInteractions,
        propertyTypeSecondWithMoreInteractions:
          secondPropertyTypeWithMoreInteractions,
        propertyTypeWithLessInteractions
      })}
      loading={false}
      renderChart={() => (
        <PieChart
          data={userInteractionStatistics}
          pieRadius={pieRadius}
          labelPosition={labelPosition}
        />
      )}
      renderTable={() => (
        <Table
          data={userInteractionStatistics}
          valueKey="percentage"
          labelKeys={['chart.table.property.type', 'chart.table.percentage']}
          formatValue={value => `${value}%`}
        />
      )}
    />
  );
};

export default UserInteractionChartContainer;

UserInteractionChartContainer.propTypes = {
  location: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string
  }).isRequired
};
